<template>
  <v-menu bottom left>
    <template v-slot:activator="{ on, attrs }">
      <v-btn icon v-bind="attrs" v-on="on">
        <v-icon>mdi-dots-vertical</v-icon>
      </v-btn>
    </template>

    <v-list>
      <v-list-item @click="$emit('setDefaultMethod', payment_method)" v-if="!payment_method.default">
        <v-list-item-icon class="mr-3">
          <v-icon>mdi-star-outline</v-icon>
        </v-list-item-icon>
        <v-list-item-title>Set as default</v-list-item-title>
      </v-list-item>

      <v-list-item v-if="payment_method.default && count > 1">
        <v-list-item-icon class="mr-3">
          <v-icon>mdi-trash-can-outline</v-icon>
        </v-list-item-icon>
        <v-list-item-title>Can't delete your default card.</v-list-item-title>
      </v-list-item>
      <v-list-item v-else @click="$emit('deleteMethod', payment_method)">
        <v-list-item-icon class="mr-3">
          <v-icon>mdi-trash-can-outline</v-icon>
        </v-list-item-icon>
        <v-list-item-title>Delete</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>  
</template>

<script>
export default {
  name: 'PaymentMethodMenu',

  props: ['payment_method', 'count'],
}
</script>